<template>
  <div class="card-body">
    <h4 class="card-title mb-2">
      <!-- {{ $t("education.education-career") }} -->
      {{ $t("overview.advanced") }}
    </h4>
    <b-tabs
      content-class="crypto-buy-sell-nav-content"
      nav-class="nav-tabs-custom"
    >    
    <b-tab :title="$t('advanced.education')" v-if="id_template == 1 || id_template == 5">
        <div v-if="loadingedu || loading" class="mt-4 mx-auto">
          <div class="text-center p-5">
            <div class="spinner-border text-secondary" role="status"></div>
          </div>
        </div>
        <simplebar style="max-height: 60vh" class="mt-3" v-if="education.nipd">
          <table class="table table-bordered px-2">
            <tbody>
              <tr>
                <td width="20%">
                  <div class="mt-3">{{ $t("education.name") }}</div>
                </td>
                <td>
                  <div class="row">
                    <div class="col-sm-10 mt-3">
                      <b>{{ education.nm_pd }}</b>
                    </div>
                    <div
                      class="col-sm-2 text-right"
                      v-if="
                        id_user === id_analys ||
                        id_user === manager ||
                        user_type === 'superadmin' ||
                        user_type === 'admin' ||
                        user_type === 'vvip'
                      "
                    >
                      <b-dropdown
                        class="chat-noti-dropdown active"
                        right
                        variant="white"
                      >
                        <template v-slot:button-content>
                          <i class="bx bx-sm bx-dots-vertical-rounded"></i>
                        </template>
                        <b-dropdown-item
                          ><router-link :to="{ path: '/education-search', query: { target: id } }">{{
                            $t("education.education-search")
                          }}</router-link></b-dropdown-item
                        >
                        <b-dropdown-item
                          @click="deleteEducationTarget(education.id_edu)"
                          class="text-danger"
                          >{{ $t("button.hapus.text") }}</b-dropdown-item
                        >
                      </b-dropdown>
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <td width="20%">NIM</td>
                <td>
                  {{ education.nipd }}
                </td>
              </tr>
              <tr>
                <td width="20%">
                  {{ $t("education.perguruan-tinggi") }}
                </td>
                <td>
                  {{ education.namapt }}
                </td>
              </tr>
              <tr>
                <td width="20%">
                  {{ $t("education.jenjang") }}
                </td>
                <td>
                  {{ education.namajenjang }}
                </td>
              </tr>
              <tr>
                <td width="20%">
                  {{ $t("education.program-studi") }}
                </td>
                <td>
                  {{ education.namaprodi }}
                </td>
              </tr>
              <tr>
                <td width="20%">
                  {{ $t("education.jenis-kelamin") }}
                </td>
                <td>
                  {{ education.jk }}
                </td>
              </tr>
              <tr>
                <td width="20%">
                  {{ $t("education.semester-awal") }}
                </td>
                <td>
                  {{ education.mulai_smt }}
                </td>
              </tr>
              <tr>
                <td width="20%">
                  {{ $t("education.status-awal") }}
                </td>
                <td>
                  {{ education.nm_jns_daftar }}
                </td>
              </tr>
              <tr v-if="education.nama_pt_asal">
                <td width="20%">
                  {{ $t("education.nama-pt-awal") }}
                </td>
                <td>
                  {{ education.nama_pt_asal }}
                </td>
              </tr>
              <tr v-if="education.nm_prodi_asal">
                <td width="20%">
                  {{ $t("education.prodi-asal") }}
                </td>
                <td>
                  {{ education.nm_prodi_asal }}
                </td>
              </tr>
              <tr v-if="education.ket_keluar">
                <td width="20%">
                  {{ $t("education.status") }}
                </td>
                <td>
                  {{ education.ket_keluar }}
                </td>
              </tr>
              <tr v-if="education.tgl_keluar">
                <td width="20%">
                  {{ $t("education.tanggal-lulus") }}
                </td>
                <td>
                  <span v-if="education.tgl_keluar"
                    >{{ formatDate(education.tgl_keluar) }}
                  </span>
                </td>
              </tr>
              <tr v-if="education.no_seri_ijazah">
                <td width="20%">
                  {{ $t("education.nomer-ijazah") }}
                </td>
                <td>
                  {{ education.no_seri_ijazah }}
                </td>
              </tr>
              <tr v-if="education.sert_prof">
                <td width="20%">
                  {{ $t("education.sertifikasi-profesi") }}
                </td>
                <td>
                  {{ education.sert_prof }}
                </td>
              </tr>
            </tbody>
          </table>
        </simplebar>
        <div
          class="div pt-5 pb-5"
          v-if="!education.id_edu && !loadingedu && !loading"
        >
          <p class="text-center">{{ $t("overview.table.all.dnf") }}</p>
          <p class="text-center">
            <router-link
              :to="{ path: '/education-search', query: { target: id } }"
            >
              <b-button
                class="btn btn-sm"
                variant="primary"
                v-if="
                  id_user === target.id_analys ||
                  id_user === target.manager ||
                  user_type === 'superadmin' ||
                  user_type === 'admin' ||
                  user_type === 'vvip'
                "
                ><i class="fas fa-search"></i>
                {{ $t("overview.add-from-internet.text") }}</b-button
              >
            </router-link>
          </p>
        </div>
    </b-tab>

    <b-tab :title="$t('advanced.career')" v-if="id_template == 1 || id_template == 5">
      <div class="card pt-0 h-100">
        <div v-if="loadingcareer || loading" class="mt-4 mx-auto">
          <div class="text-center p-5">
            <div class="spinner-border text-secondary" role="status"></div>
          </div>
        </div>
        <simplebar
          style="max-height: 60vh"
          class="mt-3"
          v-if="career.profile_id"
        >
          <table class="table table-bordered px-2">
            <tbody>
              <tr>
                <td width="20%">
                  <div class="">
                    {{ $t("education.avatar") }}
                  </div>
                </td>
                <td>
                  <div class="row">
                    <div class="col-sm-10">
                      <img
                        :src="career.profile_picture"
                        alt=""
                        class="img-fluid rounded avatar-md"
                        srcset=""
                      />
                    </div>
                    <div class="col-sm-2 text-right">
                      <!-- <b-button class="btn btn-sm" @click="deleteCareerTarget(career.id_linkedin)" variant="danger"></i></b-button> -->
                      <b-dropdown
                        class="chat-noti-dropdown active"
                        right
                        variant="white"
                        v-if="
                          id_user === id_analys ||
                          id_user === manager ||
                          user_type === 'superadmin' ||
                          user_type === 'admin' ||
                          user_type === 'vvip'
                        "
                      >
                        <template v-slot:button-content>
                          <i class="bx bx-sm bx-dots-vertical-rounded"></i>
                        </template>
                        <b-dropdown-item
                          ><router-link
                            :to="{
                              path: '/career-search',
                              query: { target: id },
                            }"
                            >{{ $t("education.career-search") }}</router-link
                          ></b-dropdown-item
                        >
                        <b-dropdown-item
                          @click="deleteCareerTarget(career.id_linkedin)"
                          class="text-danger"
                          >{{ $t("button.hapus.text") }}</b-dropdown-item
                        >
                      </b-dropdown>
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <td width="20%">
                  {{ $t("education.profil_id") }}
                </td>
                <td>
                  {{ career.profile_id }}
                </td>
              </tr>
              <tr>
                <td width="20%">
                  {{ $t("education.first_name") }}
                </td>
                <td>
                  {{ career.first_name }}
                </td>
              </tr>
              <tr>
                <td width="20%">
                  {{ $t("education.last_name") }}
                </td>
                <td>
                  {{ career.last_name }}
                </td>
              </tr>
              <tr>
                <td width="20%">
                  {{ $t("education.position") }}
                </td>
                <td>
                  <div
                    v-for="(position, index) in profile_positions"
                    :key="index"
                    class="border mb-2 p-2"
                  >
                    <span v-if="position.company"
                      ><img
                        :src="position.company.logo"
                        alt=""
                        class="img-fluid rounded avatar-xs mb-1"
                        srcset=""
                        v-if="position.company.logo !== null"
                      />
                      <img
                        src="https://static-exp1.licdn.com/sc/h/3dtfvv2esz58o2zimai1h3v2d"
                        alt=""
                        class="img-fluid rounded avatar-xs mb-1"
                        srcset=""
                        v-else
                      /><br />
                    </span>
                    <span v-if="position.company">
                      <b>{{ $t("education.company") }} : </b
                      >{{ position.company.name }} <br
                    /></span>
                    <span v-if="position.profile_positions"
                      ><b>{{ $t("education.title") }} :</b>
                      {{ position.profile_positions[0].title }} <br />
                    </span>
                    <span v-if="position.profile_positions">
                      <b>{{ $t("education.location") }} : </b>
                      {{ position.profile_positions[0].location }} <br
                    /></span>
                    <div v-if="position.date">
                      <b v-if="position.date.start"
                        >{{ $t("education.start") }} :
                      </b>
                      <span v-if="position.date.start"
                        >{{ position.date.start.year }} -
                        {{ formatMonth(position.date.start.month) }}</span
                      >
                      <br />
                    </div>
                    <div v-if="position.date">
                      <b v-if="position.date.end">
                        {{ $t("education.end") }} :
                      </b>
                      <span v-if="position.date.end"
                        >{{ position.date.end.year }} -
                        {{ formatMonth(position.date.end.month) }} </span
                      ><br />
                    </div>
                  </div>
                </td>
              </tr>
              <tr v-if="skills">
                <td width="20%">
                  {{ $t("education.skills") }}
                </td>
                <td>
                  <span
                    v-for="(sk, index) in skills"
                    :key="index"
                    class="btn btn-sm btn-light mr-1 mb-1 text-secondary"
                    >{{ sk }}
                  </span>
                </td>
              </tr>
              <tr v-if="certifications.lenght > 0">
                <td width="20%">
                  {{ $t("education.sertifikat") }}
                </td>
                <td>
                  <div
                    v-for="(cer, index) in certifications"
                    :key="index"
                    class="border mb-2 p-2"
                  >
                    <span v-if="cer.company"
                      ><img
                        :src="cer.company.logo"
                        alt=""
                        class="img-fluid rounded avatar-sm mb-1"
                        srcset=""
                      /><br />
                    </span>
                    <span v-if="cer.name"
                      ><b>{{ $t("education.name") }} :</b> {{ cer.name }}
                      <br />
                    </span>
                    <span v-if="cer.date"
                      ><b>{{ $t("education.year") }} : </b>
                      {{ cer.date.start.year }} -
                      {{ formatMonth(cer.date.start.month) }} <br />
                    </span>
                    <span v-if="cer.license_number">
                      <b>{{ $t("education.licensi-number") }} : </b
                      >{{ cer.license_number }} <br
                    /></span>
                    <span v-if="cer.url"
                      ><b>{{ $t("education.link") }} : </b>
                      <a
                        :href="cer.url"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {{ cer.url }} </a
                      ><br
                    /></span>
                    <span v-if="cer.display_source"
                      ><b>{{ $t("education.source") }} : </b
                      >{{ cer.display_source }}<br />
                    </span>
                    <span v-if="cer.authority">
                      <b>{{ $t("education.authority") }} : </b
                      >{{ cer.authority }}<br />
                    </span>
                  </div>
                </td>
              </tr>
              <tr v-if="publications.length > 0">
                <td width="20%">
                  {{ $t("education.publications") }}
                </td>
                <td>
                  <div
                    v-for="(publics, index) in publications"
                    :key="index"
                    class="border mb-2 p-2"
                  >
                    <span
                      ><b>{{ $t("education.headline") }} : </b>
                      <a
                        :href="publics.url"
                        target="_blank"
                        rel="noopener noreferrer"
                        >{{ publics.name }}</a
                      ></span
                    >
                    <br />
                    <span
                      ><b> {{ $t("education.date") }} : </b
                      ><span v-if="publics.date.day">{{
                        publics.date.day
                      }}</span
                      ><span v-if="publics.date.month">
                        {{ formatMonth(publics.date.month) }}</span
                      >
                      {{ publics.date.year }}</span
                    >
                    <br />
                    <span
                      ><b> {{ $t("education.publiser") }} : </b
                      >{{ publics.publisher }}</span
                    >
                    <br />
                    <b> {{ $t("education.authors") }} : </b
                    ><span
                      v-for="(ath, index) in publics.authors"
                      :key="index"
                      >({{ ath.first_name }} {{ ath.last_name }},
                      {{ ath.headline }}, {{ ath.type }}),
                    </span>
                    <br />
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </simplebar>
        <div
          class="div pt-5 pb-5"
          v-if="!career.profile_id && !loadingcareer && !loading"
        >
          <p class="text-center">{{ $t("overview.table.all.dnf") }}</p>
          <p class="text-center">
            <router-link
              :to="{ path: '/career-search', query: { target: id } }"
            >
              <b-button
                class="btn btn-sm"
                variant="primary"
                v-if="
                  id_user === target.id_analys ||
                  id_user === target.manager ||
                  user_type === 'superadmin' ||
                  user_type === 'admin' ||
                  user_type === 'vvip'
                "
                ><i class="fas fa-search"></i>
                {{ $t("overview.add-from-internet.text") }}</b-button
              >
            </router-link>
          </p>
        </div>
      </div>
    </b-tab>

    <b-tab :title="$t('advanced.social-media-database')" v-if="id_template == 1 || id_template == 5">
        <div class="card mt-4">
            <table
              class="table-profile table table-bordered text-left"
              v-if="target.advanced_fb"
            >
              <tbody>
                <tr>
                  <td width="20%">
                    <b>{{ $t("advanced.name") }}</b>
                  </td>
                  <td width="80%">
                    <div class="row">
                      <div class="col-sm-10">
                        {{
                          advanced_socmed.first_name +
                          " " +
                          advanced_socmed.last_name
                        }}
                      </div>
                      <div class="col-sm-2 text-right">
                        <b-dropdown
                          class="chat-noti-dropdown active"
                          right
                          variant="white"
                          v-if="
                            id_user === target.id_analys ||
                            id_user === target.manager ||
                            user_type === 'superadmin' ||
                            user_type === 'admin' ||
                            user_type === 'vvip'
                          "
                        >
                          <template v-slot:button-content>
                            <i
                              class="bx bx-sm bx-dots-vertical-rounded"
                            ></i>
                          </template>
                          <b-dropdown-item
                            ><router-link to="/advanced-search">{{
                              $t("advanced.advanced-search")
                            }}</router-link></b-dropdown-item
                          >
                          <b-dropdown-item
                            @click="
                              deleteAdvancedFB(
                                advanced_socmed.id_advanced_fb
                              )
                            "
                            class="text-danger"
                          >
                            {{ $t("button.hapus.text") }}</b-dropdown-item
                          >
                        </b-dropdown>
                      </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td width="20%">
                    <b>{{ $t("advanced.gender") }}</b>
                  </td>
                  <td width="80%">{{ advanced_socmed.gender }}</td>
                </tr>
                <tr>
                  <td width="20%">
                    <b>{{ $t("advanced.phone") }}</b>
                  </td>
                  <td width="80%">{{ advanced_socmed.phone }}</td>
                </tr>
                <tr>
                  <td width="20%">
                    <b>{{ $t("advanced.hometown") }}</b>
                  </td>
                  <td width="80%"><span v-if="advanced_socmed.hometown">{{ advanced_socmed.hometown }}</span><span v-else>-</span></td>
                </tr>
                <tr>
                  <td width="20%">
                    <b>{{ $t("advanced.city") }}</b>
                  </td>
                  <td width="80%"><span v-if="advanced_socmed.current_city">{{ advanced_socmed.current_city }}</span><span v-else>-</span></td>
                </tr>
                <tr>
                  <td width="20%">
                    <b>{{ $t("advanced.work") }}</b>
                  </td>
                  <td width="80%"><span v-if="advanced_socmed.work">{{ advanced_socmed.work }}</span><span v-else>-</span></td>
                </tr>
                <tr>
                  <td width="20%"><b>Status</b></td>
                  <td width="80%"><span v-if="advanced_socmed.status">{{ advanced_socmed.status }}</span><span v-else>-</span></td>
                </tr>
              </tbody>
            </table>
            <div class="div mt-5 mb-5" v-else>
              <div>
                <p class="text-center">
                  {{ $t("overview.table.all.dnf") }}
                </p>
                <p
                  class="text-center"
                  v-if="
                    id_user === target.id_analys ||
                    id_user === target.manager ||
                    user_type === 'superadmin' ||
                    user_type === 'admin' ||
                    user_type === 'vvip'
                  "
                >
                  <router-link
                    to="/advanced-search"
                    class="btn btn-sm btn-primary"
                  >
                    <i class="fas fa-search"></i>
                    {{ $t("overview.add-from-internet.text") }}
                  </router-link>
                </p>
              </div>
            </div>
        </div>
    </b-tab>

    <b-tab :title="$t('advanced.ecommerce-database')" v-if="id_template == 1 || id_template == 5">
        <div class="row">
            <div class="col-md-12">
              <div class="card mt-4">
                <table
                  class="table-profile table-bordered table text-left"
                  v-if="target.advanced_tokped"
                >
                  <tbody>
                    <tr>
                      <td width="20%">
                        <b>{{ $t("advanced.name") }}</b>
                      </td>
                      <td width="80%">
                        <div class="row">
                          <div class="col-sm-10">
                            {{ advanced_ecomm.full_name }}
                          </div>
                          <div class="col-sm-2 text-right">
                            <b-dropdown
                              class="chat-noti-dropdown active"
                              right
                              variant="white"
                              v-if="
                                id_user === target.id_analys ||
                                id_user === target.manager ||
                                user_type === 'superadmin' ||
                                user_type === 'admin' ||
                                user_type === 'vvip'
                              "
                            >
                              <template v-slot:button-content>
                                <i
                                  class="
                                    bx bx-sm bx-dots-vertical-rounded
                                  "
                                ></i>
                              </template>
                              <b-dropdown-item
                                ><router-link to="/advanced-search">{{
                                  $t("advanced.advanced-search")
                                }}</router-link></b-dropdown-item
                              >
                              <b-dropdown-item
                                @click="
                                  deleteAdvancedTokped(
                                    advanced_ecomm.id_advanced_tokped
                                  )
                                "
                                class="text-danger"
                              >
                                {{
                                  $t("button.hapus.text")
                                }}</b-dropdown-item
                              >
                            </b-dropdown>
                          </div>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td width="20%">
                        <b>{{ $t("advanced.gender") }}</b>
                      </td>
                      <td width="80%"><span v-if="advanced_ecomm.sex">{{ advanced_ecomm.sex }}</span><span v-else>-</span></td>
                    </tr>
                    <tr>
                      <td width="20%">
                        <b>{{ $t("advanced.phone") }}</b>
                      </td>
                      <td width="80%"><span v-if="advanced_ecomm.phone">{{ advanced_ecomm.phone }}</span><span v-else>-</span></td>
                    </tr>
                    <tr>
                      <td width="20%">
                        <b>{{ $t("advanced.email") }}</b>
                      </td>
                      <td width="80%"><span v-if="advanced_ecomm.user_email">{{ advanced_ecomm.user_email }}</span><span v-else>-</span></td>
                    </tr>
                    <tr>
                      <td width="20%">
                        <b>{{ $t("advanced.hoobies") }}</b>
                      </td>
                      <td width="80%"><span v-if="advanced_ecomm.hobbies">{{ advanced_ecomm.hobbies }}</span><span v-else>-</span></td>
                    </tr>
                    <tr>
                      <td width="20%">
                        <b>{{ $t("advanced.bithday") }}</b>
                      </td>
                      <td width="80%"><span v-if="advanced_ecomm.birth_date">{{ advanced_ecomm.birth_date }}</span><span v-else>-</span></td>
                    </tr>
                    <tr>
                      <td width="20%"><b>Status</b></td>
                      <td width="80%"><span v-if="advanced_ecomm.status">{{ advanced_ecomm.status }}</span><span v-else>-</span></td>
                    </tr>
                  </tbody>
                </table>
                <div class="div mt-5 mb-5" v-else>
                  <div>
                    <p class="text-center">
                      {{ $t("overview.table.all.dnf") }}
                    </p>
                    <p
                      class="text-center"
                      v-if="
                        id_user === target.id_analys ||
                        id_user === target.manager ||
                        user_type === 'superadmin' ||
                        user_type === 'admin' ||
                        user_type === 'vvip'
                      "
                    >
                      <router-link
                        to="/advanced-search"
                        class="btn btn-sm btn-primary"
                      >
                        <i class="fas fa-search"></i>
                        {{ $t("overview.add-from-internet.text") }}
                      </router-link>
                    </p>
                  </div>
                </div>
              </div>
            </div>
        </div>
    </b-tab>
        
    <b-tab :title="$t('advanced.exposed')">
        <div class="card mt-4">
            <simplebar style="max-height: 33vh" class="mt-0">
              <div class="row mt-0 mx-3" v-if="data_breach[0]">
                <div
                  v-for="(e, index) in data_breach"
                  :key="index"
                  class="col-sm-6 py-2"
                >
                  <div
                    class="
                      d-block
                      border border-primary
                      rounded
                      p-2
                      h-100
                    "
                  >
                    <div
                      class="
                        d-flex
                        align-items-center
                        justify-content-between
                      "
                    >
                      <h5 class="text-truncate">{{ e.source }}</h5>
                      <i
                        v-if="e.has_password == 0"
                        class="bx bxs-lock bx-sm"
                      ></i>
                      <i
                        v-if="e.has_password == 1"
                        class="text-success bx bxs-lock-open bx-sm"
                      ></i>
                    </div>
                    <hr />
                    <div class="text-xs">
                      <small v-if="e.email">Email : {{ e.email }}</small
                      ><br />
                      <small v-if="e.has_password"
                        >Password : {{ e.password }}</small
                      ><br />
                      <small v-if="e.has_password"
                        >Password Hash : {{ e.hash }}</small
                      >
                    </div>
                  </div>
                </div>
              </div>
              <div class="div mt-5 mb-5" v-else>
                <div>
                  <p class="text-center">
                    {{ $t("overview.table.all.dnf") }}
                  </p>
                  <p
                    class="text-center"
                    v-if="
                      id_user === target.id_analys ||
                      id_user === target.manager ||
                      user_type === 'superadmin' ||
                      user_type === 'admin' ||
                      user_type === 'vvip'
                    "
                  >
                    <router-link
                      to="/potential-breach"
                      class="btn btn-sm btn-primary"
                    >
                      <i class="fas fa-search"></i>
                      {{ $t("overview.add-from-internet.text") }}
                    </router-link>
                  </p>
                </div>
              </div>
            </simplebar>
        </div>
    </b-tab>

    <b-tab title="Website">
        <div class="card">
          <div class="row mt-4" v-if="private_web">
            <div class="col-sm-6">
            <h5 class="px-3 py-3">  {{ $t("website.sites-info") }}</h5>
            </div>
            <div class="col-sm-6 text-right">
              <h5 class="text-primary"> {{target.private_web[0].domain}} <b-dropdown
                  class="chat-noti-dropdown active"
                  right
                  variant="white"
                  v-if="
                    id_user === id_analys ||
                    id_user === manager ||
                    user_type === 'superadmin' ||
                    user_type === 'admin' ||
                    user_type === 'vvip'
                  "
                >
                  <template v-slot:button-content>
                    <i
                      class="bx bx-sm bx-dots-vertical-rounded"
                    ></i>
                  </template>
                  <b-dropdown-item
                    class="text-danger"
                    @click="
                      deletePrivateWeb(target.private_web[0].id_private_web)
                    "
                    >{{
                      $t("button.hapus.text")
                    }}</b-dropdown-item
                  >
                </b-dropdown></h5>
             
            </div>
          </div>
          <div v-if="private_web">
              <div class="row" v-if="private_web">
                <Website
                  :id_target="id"
                  :id_user="id_user"
                  :user_type="user_type"
                  :manager="target.manager"
                  :id_analys="target.id_analys"
                />
              </div>
            <!-- <table class="table-profile table-bordered table mt-3 text-left">
              <thead>
                <tr>
                  <td width="20%"><b>Domain</b></td>
                  <td width="60%">
                    <div class="row">
                      <div class="col-sm-6">
                        <a
                          :href="
                            'http://' + private_web.webinfo.domain_name
                          "
                          target="_blank"
                        >
                          {{ private_web.webinfo.domain_name }}
                        </a>
                      </div>
                      <div class="col-sm-6 text-right">
                        <b-dropdown
                          class="chat-noti-dropdown active"
                          right
                          variant="white"
                          v-if="
                            id_user === target.id_analys ||
                            id_user === target.manager ||
                            user_type === 'superadmin' ||
                            user_type === 'admin' ||
                            user_type === 'vvip'
                          "
                        >
                          <template v-slot:button-content>
                            <i
                              class="bx bx-sm bx-dots-vertical-rounded"
                            ></i>
                          </template>
                          <b-dropdown-item
                            class="text-danger"
                            @click="
                              deletePrivateWeb(
                                private_web.id_private_web
                              )
                            "
                            >{{
                              $t("button.hapus.text")
                            }}</b-dropdown-item
                          >
                        </b-dropdown>
                      </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td width="20%">
                    <b>{{ $t("website.ip") }}</b>
                  </td>
                  <td width="60%">
                    <div class="row">
                      <div class="col-sm-6">
                        {{ private_web.webinfo.ip_address }}
                      </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td width="20%">
                    <b>{{ $t("website.ip_location") }}</b>
                  </td>
                  <td width="60%">
                    <div class="row">
                      <div class="col-sm-6">
                        {{ private_web.webinfo.hosting_country }} ({{
                          private_web.webinfo.ip_location
                        }})
                      </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td width="20%">
                    <b>{{ $t("website.hosting_company") }}</b>
                  </td>
                  <td width="60%">
                    <div class="row">
                      <div class="col-sm-6">
                        {{ private_web.webinfo.hosting_company }}
                      </div>
                    </div>
                  </td>
                </tr>
              </thead>
            </table> -->
          </div>
          <div class="div" v-else>
            <p class="text-center pt-5">
              {{ $t("overview.table.all.dnf") }}
            </p>
            <div
              v-if="
                id_user === target.id_analys ||
                id_user === target.manager ||
                user_type === 'superadmin' ||
                user_type === 'admin' ||
                user_type === 'vvip'
              "
            >
              <p class="text-center pt-1 pb-4">
                <b-button
                  class="btn btn-sm mr-1"
                  variant="primary"
                  @click="addWebsite(id)"
                  ><i class="fas fa-user-plus"></i>
                  {{ $t("overview.add-from-database.text") }}</b-button
                ><b-button
                  class="btn btn-sm"
                  variant="primary"
                  @click="addWebsiteSearch(id)"
                  ><i class="fas fa-search"></i>
                  {{ $t("overview.add-from-internet.text") }}</b-button
                >
              </p>
            </div>
          </div>
        </div>
    </b-tab>

    </b-tabs>
    
    <!-- add website -->
    <b-modal
      size="lg"
      ref="modal-add-website"
      :id="'modal-add-website'"
      centered
      title="Add Website"
      title-class="font-18"
      hide-footer
    >
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-body">
              <div class="row mt-1">
                <div class="col-sm-12 col-md-6">
                  <div id="tickets-table_length" class="dataTables_length">
                    <label class="d-inline-flex align-items-center">
                      Show&nbsp;&nbsp;
                      <b-form-select
                        v-model="perPage"
                        size="sm"
                        :options="pageOptions"
                        class="mx-1"
                      ></b-form-select
                      >&nbsp;&nbsp;entries
                    </label>
                  </div>
                </div>
                <!-- Search -->
                <div class="col-sm-12 col-md-6">
                  <div
                    id="tickets-table_filter"
                    class="dataTables_filter text-md-right"
                  >
                    <label class="d-inline-flex align-items-center">
                      Search:
                      <b-form-input
                        v-model="filter"
                        type="search"
                        placeholder="Search..."
                        class="form-control form-control ml-2"
                      ></b-form-input>
                    </label>
                  </div>
                </div>
                <!-- End search -->
              </div>
              <!-- Table -->
              <div class="table-responsive mb-0">
                <div class="table-responsive mb-0">
                  <b-table
                    :items="list_website"
                    :fields="fieldsWebsite"
                    striped
                    bordered
                    responsive="sm"
                    :per-page="perPage"
                    :current-page="currentPage"
                    :sort-desc.sync="sortDesc"
                    :filter="filter"
                    :filter-included-fields="filterOn"
                  >
                    <template #cell(actions)="row">
                      <b-button
                        class="mr-2 btn-sm"
                        @click="
                          addWebsiteTarget(
                            row.item.id_web_info,
                            row.item.domain_name
                          )
                        "
                        variant="primary"
                      >
                        <i class="bx bx-plus"></i>
                      </b-button>
                    </template>
                  </b-table>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <div
                    class="
                      dataTables_paginate
                      paging_simple_numbers
                      float-right
                    "
                  >
                    <ul class="pagination pagination-rounded mb-0">
                      <!-- pagination -->
                      <b-pagination
                        v-model="currentPage"
                        :total-rows="rowsWebsite"
                        :per-page="perPage"
                      ></b-pagination>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-modal>

    <b-modal
      size="xl"
      ref="modal-add-website-search"
      :id="'modal-add-website-search'"
      centered
      title="Add Website"
      title-class="font-18"
      hide-footer
    >
      <div class="row">
        <div class="col-12">
          <div class="card px-4">
            <div class="row mt-5">
              <div class="col-sm-12 text-right">
                <div class="input-group">
                  <input
                    id="search"
                    type="text"
                    class="form-control"
                    v-model="searchKeyWebsite"
                    placeholder="domainname.com"
                    aria-describedby="search"
                    v-on:input="removeHttp(searchKeyWebsite)"
                  />
                  <div class="input-group-prepend">
                    <button
                      id="search"
                      class="input-group-text bg-primary text-white"
                      @click="searchWebsiteInfo"
                    >
                      <i class="bx bx-search-alt search-icon"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div class="row mt-4">
              <div
                class="col-sm-12"
                v-if="
                  !searchWebsite &&
                  !SearchResultWebsite[0] &&
                  !loadingsearchwebsite
                "
              >
                <div class="p-5 m-5 justify-content-center text-secondary">
                  <h4 class="text-center py-5 my-5">...</h4>
                </div>
              </div>
              <div
                class="col-sm-12"
                v-if="
                  searchWebsite &&
                  !loadingsearchwebsite &&
                  error == '' &&
                  !SearchResultWebsite
                "
              >
                <div class="p-5 m-5 justify-content-center">
                  <h6 class="text-center py-5 my-5 text-secondary">
                    {{ $t("all.dnf") }}
                  </h6>
                </div>
              </div>
              <div
                v-if="error !== '' && !loadingsearchwebsite"
                class="row mt-5 mb-5 pb-4 mx-auto"
              >
                <div class="text-center">
                  <span class="text-secondary">{{ error }}</span>
                </div>
              </div>
              <div
                class="col-sm-12"
                v-if="SearchResultWebsite == 0 && loadingsearchwebsite"
              >
                <div class="p-5 m-5 text-center">
                  <b-spinner label="Loading..."></b-spinner><br />
                  Loading..
                </div>
              </div>
              <div class="col-sm-12" v-if="SearchResultWebsite">
                <p v-if="SearchResultWebsite.visitors">
                  <b>{{ $t("website.visitors") }}: </b>
                  {{ SearchResultWebsite.visitors }}
                </p>
                <p v-if="SearchResultWebsite.ip_address">
                  <b>{{ $t("website.ip") }}: </b>
                  {{ SearchResultWebsite.ip_address }}
                </p>
                <p v-if="SearchResultWebsite.link_ipv6_address">
                  <b>{{ $t("website.visitors") }}: </b>
                  {{ SearchResultWebsite.link_ipv6_address }}
                </p>
                <p v-if="SearchResultWebsite.ip_location">
                  <b>{{ $t("website.ip_location") }}: </b>
                  {{ SearchResultWebsite.ip_location }}
                </p>
                <p v-if="SearchResultWebsite.ip_reverse_dns">
                  <b>{{ $t("website.ip_reserve_dns") }}: </b>
                  {{ SearchResultWebsite.ip_reverse_dns }}
                </p>
                <p v-if="SearchResultWebsite.hosting_company">
                  <b>{{ $t("website.hosting_company") }}: </b>
                  {{ SearchResultWebsite.hosting_company }}
                </p>
                <p v-if="SearchResultWebsite.hosting_ip_range">
                  <b>{{ $t("website.hosting_ip_range") }}: </b>
                  {{ SearchResultWebsite.hosting_ip_range }}
                </p>
                <p v-if="SearchResultWebsite.hosting_address">
                  <b>{{ $t("website.hosting_address") }}: </b>
                  {{ SearchResultWebsite.hosting_address }}
                </p>
                <p v-if="SearchResultWebsite.hosting_country">
                  <b>{{ $t("website.hosting_country") }}: </b>
                  {{ SearchResultWebsite.hosting_country }}
                </p>
                <p v-if="SearchResultWebsite.hosting_phone">
                  <b>{{ $t("website.hosting_phone") }}: </b>
                  {{ SearchResultWebsite.hosting_phone }}
                </p>
                <p v-if="SearchResultWebsite.cidr">
                  <b>{{ $t("website.cidr") }}: </b>
                  {{ SearchResultWebsite.cidr }}
                </p>
                <p v-if="SearchResultWebsite.hosting_cidr">
                  <b>{{ $t("website.hosting_cidr") }}: </b>
                  {{ SearchResultWebsite.hosting_cidr }}
                </p>
                <div class="col-sm-12 text-right ">
                  <b-button
                    class="btn mr-1"
                    variant="secondary"
                    size="sm"
                    @click="clearData"
                    ><i class="fa fa-times"></i> Clear</b-button
                  >
                  &nbsp;
                  <b-button
                    class="btn"
                    variant="success"
                    size="sm"
                    @click="saveWebsiteInfo"
                    ><i class="fa fa-check"></i> Save</b-button
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-modal>
    
  </div>
</template>

<script>
import SocmedService from "@/helpers/socmed.service";
import { gmapApi } from "vue2-google-maps";
import TargetService from "@/helpers/target-profile.service";
import EducationService from "@/helpers/education.service";
import AdvancedService from "@/helpers/advanced.service";
import WebsiteService from "@/helpers/website.service";
import Website from "./website.vue";
import Swal from "sweetalert2";
import moment from "moment";
import simplebar from "simplebar-vue";

export default {
  props: ["id_target", "id_analys", "manager", "id_user", "user_type", "id_template"],

  components: { simplebar, Website },
  data() {
    return {
      id: this.id_target,
      searchWebsite: false,
      loadingsearchwebsite: false,
      error: '',
      searchKeyWebsite: "",
      SearchResultWebsite: "",
      title: "Education",
      loading: false,
      loadingedu: false,
      loadingcareer: false,
      target: "",
      career: "",
      advanced_ecomm: [],
      advanced_socmed: [],
      list_website: [],
      exposed: [],
      data_breach: "",
      private_web: "",
      skills: "",
      profile_positions: "",
      certifications: "",
      publications: "",
      education: "",
      fieldsWebsite: [
        { key: "id_web_info", thClass: "d-none", tdClass: "d-none" },
        { key: "domain_name", sortable: true, label: "Domain Name" },
        {
          key: "ip_address",
          sortable: true,
          class: "text-center",
          label: "IP Address",
        },
        {
          key: "ip_location",
          sortable: true,
          class: "text-center",
          label: "IP Location",
        },
        {
          key: "actions",
          class: "text-center",
          label: this.$t("twitter.table.action"),
        },
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortDesc: false,
    };
  },

  watch: {
    linkedin: {
      immediate: true,
      handler(n, o) {
        this.getCareerTarget();
      },
    },
    ppdikti: {
      immediate: true,
      handler(n, o) {
        this.getEduTarget();
      },
    },
  },
  
  computed: {
    rowsWebsite() {
      return this.list_website.length;
    },
    criteria() {
      return this.searching.trim().toLowerCase();
    },
    availableOptions() {
      const criteria = this.criteria;
      let element = [];
      try {
        for (let i = 0; i < this.relation.length; i++) {
          element.push(JSON.parse(this.relation[i]).id);
        }
      } catch (e) {
        element = [];
      }
      const options = this.options.filter(
        (opt) => element.indexOf(opt.id) === -1 && opt.id != this.id
      );
      this.show = false;
      if (criteria) {
        this.show = true;
        return options.filter((opt) =>
          opt.name.toLowerCase().includes(criteria)
        );
      }
      return options;
    },
    // searchDesc() {
    //   if (this.criteria && this.availableOptions.length === 0) {
    //     return this.$t("wizard.form.validation.not_match1");
    //   }
    //   return "";
    // },
  },

  methods: {
    async getTargetDetail() {
      this.loading = true;
      await TargetService.getDetailTarget(this.id)
        .then((response) => {
          // console.log("Target Detail =========> ", response);
          this.target = response.data.data;
          this.advanced_socmed = response.data.data.advanced_fb;
          this.advanced_ecomm = response.data.data.advanced_tokped;
          this.private_web = response.data.data.private_web[0];
          this.loading = false;
        })
        .catch((err) => {
          console.log("d target -> ", err);
          this.loading = false;
        });
      await this.getCareerTarget();
      await this.getEduTarget();
    },
     // website
    searchWebsiteInfo() {
      this.error = "";
      this.loadingsearchwebsite = true;
      this.searchWebsite = true;
      this.SearchResultWebsite = "";
      const data = {
        website: this.searchKeyWebsite,
      };
      WebsiteService.searchWebInfo(data)
        .then((response) => {
          this.SearchResultWebsite = response.data.output;
          this.loadingsearchwebsite = false;
        })
        .catch((err) => {
          console.log(err);
          if (err.response.status == 500) {
            this.error = this.$t("all.error-500");
          } else if (err.response.status == 404) {
            this.error = this.$t("all.error-404");
          }
          this.loadingsearchwebsite = false;
        });
    },

    saveWebsiteInfo() {
      this.loadingsave = true;
      var data = {
        domain_name: this.searchKeyWebsite,
        visitors: this.SearchResultWebsite.visitors,
        ip_address: this.SearchResultWebsite.ip_address,
        link_ipv6_address: this.SearchResultWebsite.link_ipv6_address,
        ip_location: this.SearchResultWebsite.ip_location,
        ip_reverse_dns: this.SearchResultWebsite.ip_reverse_dns,
        hosting_company: this.SearchResultWebsite.hosting_company,
        hosting_ip_range: this.SearchResultWebsite.hosting_ip_range,
        hosting_address: this.SearchResultWebsite.hosting_address,
        hosting_country: this.SearchResultWebsite.hosting_country,
        hosting_phone: this.SearchResultWebsite.hosting_phone,
        hosting_website: this.SearchResultWebsite.hosting_website,
        cidr: this.SearchResultWebsite.cidr,
        hosting_cidr: this.SearchResultWebsite.hosting_cidr,
      };
      WebsiteService.createWebInfo(data)
        .then((response) => {
          this.SearchResultWebsite = "";
          this.loadingsearchtwitter = false;
          this.searchWebsite = false;
          this.searchKeyWebsite = "";
          this.savePrivateWeb(response.data.data.id_web_info);
        })
        .catch((err) => {
          console.log(err);
          this.loading = false;
        });
    },

     savePrivateWeb(idw) {
      this.loadingsave = true;
      var data = {
        id_target: this.id,
        domain: this.searchKey,
        id_ip: "",
        id_web_info: idw,
        id_whois: "",
        id_web_service: "",
        id_cms: "",
      };
      WebsiteService.createPrivateWeb(data)
        .then((response) => {
          Swal.fire(this.$t("alert.alert-save"), "", "success");
          this.getTargetDetail();
          this.addWebsiteSearchHide();
          this.searchKey = "";
          this.searchWebsite = false;
          this.loading = false;
        })
        .catch((err) => {
          console.log(err);
          this.loading = false;
        });
    },

    getDataBreach() {
      let id = this.id;
      AdvancedService.getBreach(id)
        .then((response) => {
          this.data_breach = response.data.data;
        })
        .catch((e) => {
          this.message = e.response.data.data;
        });
    },

    listWebsite() {
      WebsiteService.getWebInfo()
        .then((response) => {
          this.list_website = response.data.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },

    getCareerTarget() {
      if (this.target) {
        this.loadingcareer = true;
        EducationService.getCareer(this.target.id_linkedin)
          .then((response) => {
            this.career = response.data.data;
            this.skills = JSON.parse(response.data.data.skills);
            this.profile_positions = JSON.parse(
              response.data.data.profile_positions
            );
            this.certifications = JSON.parse(response.data.data.certifications);
            this.publications = JSON.parse(response.data.data.publications);
            this.loadingcareer = false;
          })
          .catch((err) => {
            console.log(err);
            this.loadingcareer = false;
          });
      }
    },

    getEduTarget() {
      if (this.target.id_edu) {
        this.loadingedu = true;
        EducationService.getEducation(this.target.id_edu)
          .then((response) => {
            // console.log(response.data)
            this.education = response.data.data;
            this.loadingedu = false;
          })
          .catch((err) => {
            console.log(err);
            this.loadingedu = false;
          });
      }
    },

    deleteEducationTarget(id) {
      Swal.fire({
        title: this.$t("button.delete.modal.confirmText[0]"),
        text: this.$t("button.delete.modal.confirmText[1]"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        cancelButtonText: this.$t("button.cancel.text"),
        confirmButtonText: this.$t("button.delete.text"),
      }).then((result) => {
        if (result.isConfirmed) {
          // console.log(id);
          EducationService.deleteEducation(id)
            .then((response) => {
              this.education = "";
              this.getEduTarget();
              Swal.fire({
                position: "top-end",
                icon: "success",
                title: "Data Deleted Success",
                showConfirmButton: false,
                timer: 1500,
              });
            })
            .catch((err) => {
              console.log(err);
            });
        }
      });
    },

    deleteCareerTarget(id) {
      Swal.fire({
        title: this.$t("button.delete.modal.confirmText[0]"),
        text: this.$t("button.delete.modal.confirmText[1]"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        cancelButtonText: this.$t("button.cancel.text"),
        confirmButtonText: this.$t("button.delete.text"),
      }).then((result) => {
        if (result.isConfirmed) {
          console.log();
          EducationService.deleteCareer(id)
            .then((response) => {
              this.career = "";
              this.getCareerTarget();
              Swal.fire({
                position: "top-end",
                icon: "success",
                title: "Data Deleted Success",
                showConfirmButton: false,
                timer: 1500,
              });
            })
            .catch((err) => {
              console.log(err);
            });
        }
      });
    },

    deleteAdvancedFB(id) {
      Swal.fire({
        title: this.$t("button.delete.modal.confirmText[0]"),
        text: this.$t("button.delete.modal.confirmText[1]"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        cancelButtonText: this.$t("button.cancel.text"),
        confirmButtonText: this.$t("button.delete.text"),
      }).then((result) => {
        if (result.isConfirmed) {
          AdvancedService.deleteFB(id)
            .then((response) => {
              this.getTargetDetail();
              Swal.fire({
                position: "top-end",
                icon: "success",
                title: "Data Deleted Success",
                showConfirmButton: false,
                timer: 1500,
              });
            })
            .catch((err) => {
              console.log(err);
            });
        }
      });
    },

    deleteAdvancedTokped(id) {
      Swal.fire({
        title: this.$t("button.delete.modal.confirmText[0]"),
        text: this.$t("button.delete.modal.confirmText[1]"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        cancelButtonText: this.$t("button.cancel.text"),
        confirmButtonText: this.$t("button.delete.text"),
      }).then((result) => {
        if (result.isConfirmed) {
          AdvancedService.deleteTokped(id)
            .then((response) => {
              this.getTargetDetail();
              Swal.fire({
                position: "top-end",
                icon: "success",
                title: "Data Deleted Success",
                showConfirmButton: false,
                timer: 1500,
              });
            })
            .catch((err) => {
              console.log(err);
            });
        }
      });
    },

    formatDate(value) {
      return moment(value).format("YYYY-MM-DD");
    },

    formatMonth(value) {
      if (value == 1) {
        var bulan = "Jan";
      } else if (value == 2) {
        var bulan = "Feb";
      } else if (value == 3) {
        var bulan = "Mar";
      } else if (value == 4) {
        var bulan = "Apr";
      } else if (value == 5) {
        var bulan = "Mei";
      } else if (value == 6) {
        var bulan = "Jun";
      } else if (value == 7) {
        var bulan = "Jul";
      } else if (value == 8) {
        var bulan = "Agu";
      } else if (value == 9) {
        var bulan = "Sep";
      } else if (value == 10) {
        var bulan = "Okt";
      } else if (value == 11) {
        var bulan = "Nov";
      } else if (value == 12) {
        var bulan = "Des";
      }
      return bulan;
    },

    clearData() {
      this.SearchResult = "";
      this.searchKey = "";
      this.SearchResultWebsite = "";
    },

    addWebsite(id) {
      this.$bvModal.show("modal-add-website");
    },

    addWebsiteHide() {
      this.$refs["modal-add-website"].hide();
    },

    addWebsiteSearch(id) {
      this.$bvModal.show("modal-add-website-search" + id);
    },

    addWebsiteSearchHide() {
      this.$refs["modal-add-website-search"].hide();
    },
  
    addWebsiteTarget(id_web_info, domain) {
      var data = {
        id_target: this.id,
        domain: domain,
        id_ip: "",
        id_web_info: id_web_info,
        id_whois: "",
        id_web_service: "",
        id_cms: "",
      };
      WebsiteService.createPrivateWeb(data)
        .then((response) => {
          Swal.fire(this.$t("alert.alert-save"), "", "success");
          this.getTargetDetail();
          this.addWebsiteHide();
          this.listWebsite();
          this.search = false;
          this.loading = false;
        })
        .catch((err) => {
          console.log(err);
          this.loading = false;
        });
    },
    
    deletePrivateWeb(id) {
      Swal.fire({
        title: this.$t("button.delete.modal.confirmText[0]"),
        text: this.$t("button.delete.modal.confirmText[1]"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        cancelButtonText: this.$t("button.cancel.text"),
        confirmButtonText: this.$t("button.delete.text"),
      }).then((result) => {
        if (result.isConfirmed) {
          WebsiteService.deletePrivateWebsite(id)
            .then((response) => {
              this.getTargetDetail();
              Swal.fire({
                position: "top-end",
                icon: "success",
                title: "Data Deleted Success",
                showConfirmButton: false,
                timer: 1500,
              });
            })
            .catch((err) => {
              console.log(err);
            });
        }
      });
    },

     removeHttp(url) {
      let x = url
        .replace(/(^\w+:|^)\/\//, "")
        .replace("/", "")
        .replace("www.", "");
      return (this.searchKeyWebsite = x);
    },
  },
  mounted() {
    this.getTargetDetail();
    this.getCareerTarget();
    this.getEduTarget();
    this.getDataBreach();
    this.listWebsite();
  },
};
</script>